/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import SignupService from 'cio/services/signup';

interface StepProgressArgs {
  currentStep: number;
  steps: string[];
}

export default class StepProgress extends Component<StepProgressArgs> {
  @service router!: RouterService;
  @service signup!: SignupService;
}
